import { useState } from 'react'

/**
 * This hook provides generic open/close functionality.
 * @param {bool} initial
 * @returns Object { open: true, onOpen: fn, onClose: fn }
 */
export const useOpenClose = (initial) => {
  const [open, setOpen] = useState(initial)

  return {
    open,
    onOpen: () => setOpen(true),
    onClose: () => setOpen(false),
  }
}

export default useOpenClose
